export default (
  filterValue: Nullable<{
    from?: Nullable<StringOrNumber>;
    to?: Nullable<StringOrNumber>;
  }>,
  leadingSymbol = '',
  trailingSymbol = '',
) => {
  if (!filterValue || (!filterValue.from && !filterValue.to)) {
    return '';
  }

  if (filterValue.from && filterValue.to === null) {
    return `≥${leadingSymbol}${filterValue.from}${trailingSymbol}`;
  }

  if (filterValue.from === null && filterValue.to) {
    return `≤${leadingSymbol}${filterValue.to}${trailingSymbol}`;
  }

  if (filterValue.from === filterValue.to) {
    return `${leadingSymbol}${filterValue.from}${trailingSymbol}`;
  }

  return `${leadingSymbol}${filterValue.from}${trailingSymbol} – ${leadingSymbol}${filterValue.to}${trailingSymbol}`;
};
